import { render, staticRenderFns } from "./SupplierReport.vue?vue&type=template&id=3b85be88&scoped=true"
import script from "./SupplierReport.vue?vue&type=script&lang=js"
export * from "./SupplierReport.vue?vue&type=script&lang=js"
import style0 from "./SupplierReport.vue?vue&type=style&index=0&id=3b85be88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b85be88",
  null
  
)

export default component.exports